<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-2">MAKLUMAT KENAIKAN GAJI DAN JGMM PP1/2012</h3>
            <b-form-group>
                <b-form-row class="mb-3">
                    <b-col sm="3" class="text-right">
                        <label for="AmaunTelahTerima" class="col-form-label">Amaun Dalam Buku Servis:</label>
                    </b-col>
                    <b-col sm="5">
                        <b-form-input id="AmaunTelahTerima" v-model="Obj.AmaunTelahTerima"></b-form-input>
                    </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                    <b-col sm="3" class="text-right">
                        <label for="catatan" class="col-form-label">Catatan:</label>
                    </b-col>
                    <b-col sm="5">
                        <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                        <!-- <b-form-input id="catatan" v-model="Obj.Catatan" type="textarea"></b-form-input> -->
                    </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                    <b-col sm="3" class="text-right">
                        <label for="Tarikh Kuatkuasa" class="col-form-label">Tarikh Kuatkuasa:</label>
                    </b-col>
                    <b-col sm="5">
                        <b-form-input v-model="Obj.EftDate" readonly></b-form-input>
                        <!-- <b-form-input id="catatan" v-model="Obj.Catatan" type="textarea"></b-form-input> -->
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col sm="4"></b-col>
                    <b-col sm="8">
                        <b-button variant="success" type="submit">SIMPAN</b-button>
                    </b-col>
                </b-form-row>
            </b-form-group>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun", "elemenId"],
    data() {
        return {
            Obj: {
                EftDate: "01-01-2012",
                Catatan: `Kenaikan Gaji Pegawai Perkhidmatan Persekutuan.
Pemberian kenaikan gaji  <PERATUS>% kepada pegawai perkhidmatan awam persekutuan di bawah Sistem Saraan Malaysia (SSM) mengikut PP Bil. 1/2012.`,
            },
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            tpgList: [],
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },
        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            this.Obj.elemenId = this.elemenId;
            console.log("log", this.Obj);

            GetsalaryService.setElemen8(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
            });
        }

    },
    created() {}
}
</script>
<style scoped>
.custom-input {
  /* Gaya tambahan untuk input jika diperlukan */
}

.custom-input-large {
  font-size: 1.25rem; /* Atur ukuran font lebih besar */
  padding: .75rem 1.5rem; /* Sesuaikan padding input */
  height: auto; /* Sesuaikan tinggi input */
}
</style>